export const ticketsTranslations = {
  en: {
    title: 'Tickets',
    ticketCreated: 'Ticket created',
    ticketUpdated: 'Ticket updated',
    ticketDeleted: 'Ticket deleted',
    description: 'Manage and track support tickets',
    addTicket: 'New Ticket',
    search: 'Search tickets...',
    noTickets: 'No tickets found',
    filters: {
      title: 'Filters',
      status: 'Status',
      priority: 'Priority',
      category: 'Category',
      type: 'Type',
      assignee: 'Assigned To',
      client: 'Client',
      deal: 'Contract',
      project: 'Project',
      slaBreached: 'SLA Breached',
      clearAll: 'Clear all filters'
    },
    form: {
      title: 'Ticket Details',
      client: 'Client',
      selectClient: 'Select a client...',
      subject: 'Subject',
      subjectPlaceholder: 'Enter ticket subject',
      description: 'Description',
      descriptionPlaceholder: 'Describe the issue in detail...',
      status: 'Status',
      priority: 'Priority',
      assignedTo: 'Assigned To',
      unassigned: 'Unassigned',
      estimatedHours: 'Estimated Hours',
      notifications: 'Send WhatsApp Notifications',
      notificationsHint: 'Enable automated WhatsApp notifications for this ticket',
      create: 'Create Ticket',
      update: 'Update Ticket',
      cancel: 'Cancel',
      errors: {
        clientRequired: 'Client is required',
        subjectRequired: 'Subject is required',
        descriptionRequired: 'Description is required'
      },
      // Legacy nested structure for backwards compatibility
      clientNested: {
        label: 'Client',
        placeholder: 'Select a client...'
      },
      deal: {
        label: 'Contract',
        placeholder: 'Select a contract (optional)...',
        hint: 'Link to contract for hours tracking and SLA'
      },
      project: {
        label: 'Project',
        placeholder: 'Select a project (optional)...'
      },
      ticketType: {
        label: 'Intervention Type',
        placeholder: 'Select type...'
      },
      subjectNested: {
        label: 'Subject',
        placeholder: 'Enter ticket subject'
      },
      descriptionNested: {
        label: 'Description',
        placeholder: 'Describe the issue in detail...'
      },
      estimatedHoursNested: {
        label: 'Estimated Hours',
        placeholder: 'e.g. 2.5'
      },
      statusNested: {
        label: 'Status',
        options: {
          open: 'Open',
          in_progress: 'In Progress',
          waiting: 'Waiting',
          resolved: 'Resolved',
          closed: 'Closed'
        }
      },
      priorityNested: {
        label: 'Priority',
        options: {
          low: 'Low',
          medium: 'Medium',
          high: 'High',
          urgent: 'Urgent'
        }
      },
      category: {
        label: 'Category',
        options: {
          general: 'General',
          technical: 'Technical',
          billing: 'Billing',
          feature_request: 'Feature Request',
          bug: 'Bug',
          account: 'Account',
          other: 'Other'
        }
      },
      notificationsNested: {
        label: 'Send WhatsApp Notifications',
        description: 'Enable automated WhatsApp notifications for this ticket'
      },
      buttons: {
        create: 'Create Ticket',
        update: 'Update Ticket',
        cancel: 'Cancel'
      }
    },
    details: {
      title: 'Ticket Details',
      sections: {
        info: 'Ticket Information',
        messages: 'Messages',
        activity: 'Activity',
        timeTracking: 'Time Tracking',
        sla: 'SLA'
      },
      actions: {
        back: 'Back to Tickets',
        edit: 'Edit Ticket',
        reply: 'Reply',
        resolve: 'Resolve',
        reopen: 'Reopen'
      }
    },
    status: {
      open: 'Open',
      in_progress: 'In Progress',
      waiting: 'Waiting',
      resolved: 'Resolved',
      closed: 'Closed'
    },

    priority: {
      low: 'Low',
      medium: 'Medium',
      high: 'High',
      urgent: 'Urgent'
    },

    // Ticket Types (Tipi di Intervento)
    ticketTypes: {
      title: 'Intervention Types',
      description: 'Configure intervention types for support tickets',
      selectType: 'Select type...',
      add: 'Add Type',
      edit: 'Edit Type',
      delete: 'Delete',
      name: 'Name',
      namePlaceholder: 'e.g. Technical Support',
      nameRequired: 'Name is required',
      descriptionLabel: 'Description',
      descriptionPlaceholder: 'Optional description',
      color: 'Color',
      icon: 'Icon',
      responseHours: 'Response Time (hours)',
      resolutionHours: 'Resolution Time (hours)',
      responseTime: 'Response',
      resolutionTime: 'Resolution',
      active: 'Active',
      inactive: 'Inactive',
      billable: 'Billable (deducts from hours package)',
      created: 'Intervention type created',
      updated: 'Intervention type updated',
      deleted: 'Intervention type deleted',
      confirmDelete: 'Are you sure you want to delete this intervention type?',
      generateDefaults: 'Create Defaults',
      generateConfirm: 'Do you want to create default intervention types?',
      defaultsCreated: 'Default intervention types created',
      empty: 'No intervention types configured',
      emptyHint: 'Click "Create Defaults" to get started'
    },

    // Time Tracking
    timeTracking: {
      title: 'Time Tracking',
      startTimer: 'Start Timer',
      stopTimer: 'Stop Timer',
      timerRunning: 'Timer Running',
      addEntry: 'Add Time Entry',
      editEntry: 'Edit Entry',
      entries: 'Time Entries',
      duration: 'Duration',
      durationMinutes: 'Duration (minutes)',
      description: 'Work Description',
      descriptionPlaceholder: 'Describe the work done...',
      totalHours: 'Total Hours',
      hoursWorked: 'Hours Worked',
      billable: 'Billable',
      nonBillable: 'Non-Billable',
      noEntries: 'No time entries yet',
      startedAt: 'Started',
      endedAt: 'Ended',
      user: 'Operator',
      deleteConfirm: 'Are you sure you want to delete this time entry?',
      created: 'Time entry created',
      updated: 'Time entry updated',
      deleted: 'Time entry deleted',
      manualEntry: 'Manual Entry',
      today: 'Today',
      thisWeek: 'This Week',
      thisMonth: 'This Month'
    },

    // SLA
    sla: {
      title: 'SLA Status',
      responseTime: 'Response Time',
      resolutionTime: 'Resolution Time',
      responseDue: 'Response Due',
      resolutionDue: 'Resolution Due',
      firstResponse: 'First Response',
      resolved: 'Resolved',
      dueIn: 'Due in',
      overdue: 'Overdue by',
      breached: 'SLA Breached',
      onTrack: 'On Track',
      atRisk: 'At Risk',
      compliant: 'Compliant',
      notSet: 'Not Set',
      hours: 'hours',
      days: 'days',
      minutes: 'minutes'
    },

    // Hours Package (Monte Ore)
    hoursPackage: {
      title: 'Hours Package',
      available: 'Available',
      used: 'Used',
      remaining: 'Remaining',
      total: 'Total Package',
      percentUsed: 'Used',
      alert: 'Low Hours Alert',
      alertThreshold: 'Alert Threshold',
      addHours: 'Add Hours',
      noPackage: 'No hours package',
      exhausted: 'Hours Exhausted',
      hourlyRate: 'Hourly Rate',
      selectService: 'Hours Package',
      selectPackage: 'Select hours package (optional)'
    },

    // Links
    links: {
      deal: 'Linked Contract',
      project: 'Linked Project',
      selectDeal: 'Select a contract...',
      selectProject: 'Select a project...',
      noDeal: 'No contract linked',
      noProject: 'No project linked',
      viewDeal: 'View Contract',
      viewProject: 'View Project'
    },

    // Reports
    reports: {
      title: 'Reports',
      byType: 'By Type',
      byClient: 'By Client',
      byOperator: 'By Operator',
      slaCompliance: 'SLA Compliance',
      hoursConsumption: 'Hours Consumption',
      operatorPerformance: 'Operator Performance',
      ticketsTrend: 'Tickets Trend',
      export: 'Export',
      exportCSV: 'Export CSV',
      exportExcel: 'Export Excel',
      dateRange: 'Date Range',
      avgResolutionTime: 'Avg. Resolution Time',
      avgResponseTime: 'Avg. Response Time',
      totalTickets: 'Total Tickets',
      openTickets: 'Open Tickets',
      closedTickets: 'Closed Tickets',
      complianceRate: 'Compliance Rate'
    },

    // List view
    list: {
      columns: {
        ticket: 'Ticket',
        client: 'Client',
        type: 'Type',
        status: 'Status',
        priority: 'Priority',
        sla: 'SLA',
        assignee: 'Assigned To',
        hours: 'Hours',
        created: 'Created',
        updated: 'Updated'
      },
      empty: 'No tickets found',
      emptyFiltered: 'No tickets match the current filters'
    }
  },

  it: {
    title: 'Ticket',
    ticketCreated: 'Ticket creato',
    ticketUpdated: 'Ticket aggiornato',
    ticketDeleted: 'Ticket eliminato',
    description: 'Gestisci e monitora i ticket di supporto',
    addTicket: 'Nuovo Ticket',
    search: 'Cerca ticket...',
    noTickets: 'Nessun ticket trovato',
    filters: {
      title: 'Filtri',
      status: 'Stato',
      priority: 'Priorita',
      category: 'Categoria',
      type: 'Tipo',
      assignee: 'Assegnato a',
      client: 'Cliente',
      deal: 'Contratto',
      project: 'Progetto',
      slaBreached: 'SLA Violato',
      clearAll: 'Cancella tutti i filtri'
    },
    form: {
      title: 'Dettagli Ticket',
      client: 'Cliente',
      selectClient: 'Seleziona un cliente...',
      subject: 'Oggetto',
      subjectPlaceholder: 'Inserisci oggetto del ticket',
      description: 'Descrizione',
      descriptionPlaceholder: 'Descrivi il problema in dettaglio...',
      status: 'Stato',
      priority: 'Priorita',
      assignedTo: 'Assegnato a',
      unassigned: 'Non assegnato',
      estimatedHours: 'Ore Stimate',
      notifications: 'Invia Notifiche WhatsApp',
      notificationsHint: 'Abilita notifiche WhatsApp automatiche per questo ticket',
      create: 'Crea Ticket',
      update: 'Aggiorna Ticket',
      cancel: 'Annulla',
      errors: {
        clientRequired: 'Il cliente e obbligatorio',
        subjectRequired: 'L\'oggetto e obbligatorio',
        descriptionRequired: 'La descrizione e obbligatoria'
      },
      // Legacy nested structure for backwards compatibility
      clientNested: {
        label: 'Cliente',
        placeholder: 'Seleziona un cliente...'
      },
      deal: {
        label: 'Contratto',
        placeholder: 'Seleziona un contratto (opzionale)...',
        hint: 'Collega a un contratto per tracciamento ore e SLA'
      },
      project: {
        label: 'Progetto',
        placeholder: 'Seleziona un progetto (opzionale)...'
      },
      ticketType: {
        label: 'Tipo di Intervento',
        placeholder: 'Seleziona tipo...'
      },
      subjectNested: {
        label: 'Oggetto',
        placeholder: 'Inserisci oggetto del ticket'
      },
      descriptionNested: {
        label: 'Descrizione',
        placeholder: 'Descrivi il problema in dettaglio...'
      },
      estimatedHoursNested: {
        label: 'Ore Stimate',
        placeholder: 'es. 2.5'
      },
      statusNested: {
        label: 'Stato',
        options: {
          open: 'Aperto',
          in_progress: 'In Lavorazione',
          waiting: 'In Attesa',
          resolved: 'Risolto',
          closed: 'Chiuso'
        }
      },
      priorityNested: {
        label: 'Priorita',
        options: {
          low: 'Bassa',
          medium: 'Media',
          high: 'Alta',
          urgent: 'Urgente'
        }
      },
      category: {
        label: 'Categoria',
        options: {
          general: 'Generale',
          technical: 'Tecnico',
          billing: 'Fatturazione',
          feature_request: 'Richiesta Funzionalita',
          bug: 'Bug',
          account: 'Account',
          other: 'Altro'
        }
      },
      notificationsNested: {
        label: 'Invia Notifiche WhatsApp',
        description: 'Abilita notifiche WhatsApp automatiche per questo ticket'
      },
      buttons: {
        create: 'Crea Ticket',
        update: 'Aggiorna Ticket',
        cancel: 'Annulla'
      }
    },
    details: {
      title: 'Dettagli Ticket',
      sections: {
        info: 'Informazioni Ticket',
        messages: 'Messaggi',
        activity: 'Attivita',
        timeTracking: 'Tracciamento Ore',
        sla: 'SLA'
      },
      actions: {
        back: 'Torna ai Ticket',
        edit: 'Modifica Ticket',
        reply: 'Rispondi',
        resolve: 'Risolvi',
        reopen: 'Riapri'
      }
    },
    status: {
      open: 'Aperto',
      in_progress: 'In Lavorazione',
      waiting: 'In Attesa',
      resolved: 'Risolto',
      closed: 'Chiuso'
    },

    priority: {
      low: 'Bassa',
      medium: 'Media',
      high: 'Alta',
      urgent: 'Urgente'
    },

    // Tipi di Intervento
    ticketTypes: {
      title: 'Tipi di Intervento',
      description: 'Configura i tipi di intervento per i ticket di assistenza',
      selectType: 'Seleziona tipo...',
      add: 'Aggiungi Tipo',
      edit: 'Modifica Tipo',
      delete: 'Elimina',
      name: 'Nome',
      namePlaceholder: 'es. Supporto Tecnico',
      nameRequired: 'Il nome e obbligatorio',
      descriptionLabel: 'Descrizione',
      descriptionPlaceholder: 'Descrizione opzionale',
      color: 'Colore',
      icon: 'Icona',
      responseHours: 'Tempo Risposta (ore)',
      resolutionHours: 'Tempo Risoluzione (ore)',
      responseTime: 'Risposta',
      resolutionTime: 'Risoluzione',
      active: 'Attivo',
      inactive: 'Inattivo',
      billable: 'Fatturabile (scala dal monte ore)',
      created: 'Tipo intervento creato',
      updated: 'Tipo intervento aggiornato',
      deleted: 'Tipo intervento eliminato',
      confirmDelete: 'Sei sicuro di voler eliminare questo tipo di intervento?',
      generateDefaults: 'Crea Predefiniti',
      generateConfirm: 'Vuoi creare i tipi di intervento predefiniti?',
      defaultsCreated: 'Tipi di intervento predefiniti creati',
      empty: 'Nessun tipo di intervento configurato',
      emptyHint: 'Clicca "Crea Predefiniti" per iniziare'
    },

    // Tracciamento Ore
    timeTracking: {
      title: 'Tracciamento Ore',
      startTimer: 'Avvia Timer',
      stopTimer: 'Ferma Timer',
      timerRunning: 'Timer in Corso',
      addEntry: 'Aggiungi Ore',
      editEntry: 'Modifica Voce',
      entries: 'Voci Tempo',
      duration: 'Durata',
      durationMinutes: 'Durata (minuti)',
      description: 'Descrizione Lavoro',
      descriptionPlaceholder: 'Descrivi il lavoro svolto...',
      totalHours: 'Ore Totali',
      hoursWorked: 'Ore Lavorate',
      billable: 'Fatturabile',
      nonBillable: 'Non Fatturabile',
      noEntries: 'Nessuna voce tempo',
      startedAt: 'Inizio',
      endedAt: 'Fine',
      user: 'Operatore',
      deleteConfirm: 'Sei sicuro di voler eliminare questa voce tempo?',
      created: 'Voce tempo creata',
      updated: 'Voce tempo aggiornata',
      deleted: 'Voce tempo eliminata',
      manualEntry: 'Inserimento Manuale',
      today: 'Oggi',
      thisWeek: 'Questa Settimana',
      thisMonth: 'Questo Mese'
    },

    // SLA
    sla: {
      title: 'Stato SLA',
      responseTime: 'Tempo Risposta',
      resolutionTime: 'Tempo Risoluzione',
      responseDue: 'Risposta Entro',
      resolutionDue: 'Risoluzione Entro',
      firstResponse: 'Prima Risposta',
      resolved: 'Risolto',
      dueIn: 'Scade tra',
      overdue: 'In ritardo di',
      breached: 'SLA Violato',
      onTrack: 'In Regola',
      atRisk: 'A Rischio',
      compliant: 'Conforme',
      notSet: 'Non Impostato',
      hours: 'ore',
      days: 'giorni',
      minutes: 'minuti'
    },

    // Monte Ore
    hoursPackage: {
      title: 'Monte Ore',
      available: 'Disponibili',
      used: 'Utilizzate',
      remaining: 'Rimanenti',
      total: 'Pacchetto Totale',
      percentUsed: 'Utilizzato',
      alert: 'Avviso Ore in Esaurimento',
      alertThreshold: 'Soglia Avviso',
      addHours: 'Aggiungi Ore',
      noPackage: 'Nessun monte ore',
      exhausted: 'Ore Esaurite',
      hourlyRate: 'Tariffa Oraria',
      selectService: 'Pacchetto Monte Ore',
      selectPackage: 'Seleziona pacchetto monte ore (opzionale)'
    },

    // Collegamenti
    links: {
      deal: 'Contratto Collegato',
      project: 'Progetto Collegato',
      selectDeal: 'Seleziona un contratto...',
      selectProject: 'Seleziona un progetto...',
      noDeal: 'Nessun contratto collegato',
      noProject: 'Nessun progetto collegato',
      viewDeal: 'Vedi Contratto',
      viewProject: 'Vedi Progetto'
    },

    // Report
    reports: {
      title: 'Report',
      byType: 'Per Tipo',
      byClient: 'Per Cliente',
      byOperator: 'Per Operatore',
      slaCompliance: 'Conformita SLA',
      hoursConsumption: 'Consumo Ore',
      operatorPerformance: 'Performance Operatori',
      ticketsTrend: 'Trend Ticket',
      export: 'Esporta',
      exportCSV: 'Esporta CSV',
      exportExcel: 'Esporta Excel',
      dateRange: 'Intervallo Date',
      avgResolutionTime: 'Tempo Medio Risoluzione',
      avgResponseTime: 'Tempo Medio Risposta',
      totalTickets: 'Ticket Totali',
      openTickets: 'Ticket Aperti',
      closedTickets: 'Ticket Chiusi',
      complianceRate: 'Tasso Conformita'
    },

    // Vista lista
    list: {
      columns: {
        ticket: 'Ticket',
        client: 'Cliente',
        type: 'Tipo',
        status: 'Stato',
        priority: 'Priorita',
        sla: 'SLA',
        assignee: 'Assegnato',
        hours: 'Ore',
        created: 'Creato',
        updated: 'Aggiornato'
      },
      empty: 'Nessun ticket trovato',
      emptyFiltered: 'Nessun ticket corrisponde ai filtri attuali'
    }
  }
};
